import { render, staticRenderFns } from "./InitiateProcess.vue?vue&type=template&id=4f93d8f4&scoped=true"
import script from "./InitiateProcess.vue?vue&type=script&lang=js"
export * from "./InitiateProcess.vue?vue&type=script&lang=js"
import style0 from "./InitiateProcess.vue?vue&type=style&index=0&id=4f93d8f4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f93d8f4",
  null
  
)

export default component.exports